module.exports = __webpack_public_path__ + "../resources/img/line_checkbox_selected_lt.0b735135.svg";